import PropTypes from 'prop-types';
import BizStepService from "../../services/BizStepService";
import BaseSelectorReadonlyToInputV2 from "../Select/BaseSelectorReadonlyToInputV2";

class BizStepSelector extends BaseSelectorReadonlyToInputV2 {

  constructor(props) {
    super(props, 'friendlyName', 'id');
    this.state = {
      ...this.state,
      title: props.title || 'Etapa',
      url: BizStepService.ALL_URL + '/combobox'
    };
  }
}

BizStepSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.any,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default BizStepSelector;



// WEBPACK FOOTER //
// ./src/component/BizStep/BizStepSelector.js